import React, { Component } from 'react';
import CreateUser from '../component/createUser'
import CompanyUsers from '../component/companyUsers'
import ChangePassword from '../component/ChangePassword'
import BreadcrumbNav from '../component/breadCrumbNav'
import TransitionGroup from 'react-transition-group/TransitionGroup'

import { BrowserRouter as Router, Route, Switch} from "react-router-dom";


const AcctRouter = function ({ basename = '/acctMgt'}) {
    return (
        <Router basename='custom/acctMgt'>
        <div>
        <BreadcrumbNav />
        <div >

        <TransitionGroup>
        <Switch >
          <Route exact path="/" component={CompanyUsers} />
          <Route exact path="/create" component={CreateUser} />
          <Route exact path="/changepassword" component={ChangePassword} />
          
         </Switch>
        
        </TransitionGroup>
    

        </div>

        </div>
    
      </Router>

    )
  }
  
  export default AcctRouter